import { useState } from 'react';
import { ListOfFilesBaseProps } from '../ListOfFiles.types';
import { FileRowContainer } from '../shared/FileRowContainer';
import { renderFilename } from '../shared/renderFilename';

const FlatFilesList = ({ uploadedFiles, renderHeaderComponent }: ListOfFilesBaseProps): React.ReactElement => {
  const [onHoverCategory, setOnHoverCategory] = useState<string>('');

  return (
    <>
      {uploadedFiles.map((item, index) => {
        if (!item?.fileContents?.length) return null;

        return (
          <FileRowContainer
            key={`uploaded-file-container-${item.name}`}
            fileName={item.name}
            onMouseEnter={() => setOnHoverCategory(item.name)}
            onMouseLeave={() => setOnHoverCategory('')}
          >
            <div className="flex items-center h-[30px]">
              {renderFilename(item.name, false)}
              {renderHeaderComponent?.(item, index, onHoverCategory === item.name)}
            </div>
          </FileRowContainer>
        );
      })}
    </>
  );
};

export default FlatFilesList;
